import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import {
  SupervisiLimbahItemPatch,
  SupervisiLimbahListFilter
} from "@/types/SupervisiLimbah";

async function list(params: SupervisiLimbahListFilter = {}) {
  const response = await http
    .getDataParam("/supervisi-limbah", { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/supervisi-limbah/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function create(data: {
  tanggal_supervisi: string;
  kepala_unit_nama_manual: string | null;
}) {
  const response = await http
    .postData("/supervisi-limbah", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(
  id: number,
  data: {
    tanggal_supervisi?: string;
    kepala_unit_nama_manual?: string | null;
    kesimpulan?: string | null;
  }
) {
  const response = await http
    .putData(`/supervisi-limbah/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateItems(id: number, items: SupervisiLimbahItemPatch[]) {
  const response = await http
    .putData(`/supervisi-limbah/${id}/items`, { items })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signSupervisor(id: number, data: { password: string }) {
  const response = await http.putData(
    `/supervisi-limbah/${id}/sign-supervisor`,
    data
  );
  return response;
}

async function signKepalaUnit(id: number, data: { password: string }) {
  const response = await http.putData(
    `/supervisi-limbah/${id}/sign-kepala-unit`,
    data
  );
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/supervisi-limbah/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

function printPdf(id: number) {
  window.open(`${http.getAPI()}/supervisi-limbah/${id}/pdf`, "_blank");
}

export default {
  list,
  find,
  create,
  update,
  updateItems,
  signSupervisor,
  signKepalaUnit,
  destroy,
  printPdf
};
